 <template>
  <v-app>
    <portal to="append-inputs-grupo-filial">
      <ConverterEmbalagem dark class="text-no-wrap mr-4" />
    </portal>

    <Breadcrumb
      :atualizarSilenciadosBreadcrumb="atualizarSilenciadosBreadcrumb"
      @atualizar-tela-compras="() => { buscarTotais();atualizarProdutos++ }"
    />
    <v-layout wrap>
      <v-flex xs7>
        <Menu
          :cards="cards"
          @cardSelecionado="cardSelecionado = $event"
        ></Menu>
        <Produtos
          v-if="cardSelecionado"
          :cardSelecionado="cardSelecionado"
          :atualizarProdutos="atualizarProdutos"
          @atualizarSilenciados="atualizarSilenciados = $event"
          @detalhesFornecedor="detalhesFornecedor = $event"
          @atualizarTabela="atualizarProdutosTotal"
          :atualizarTelaCompras="atualizarTelaCompras"
          :detalhesFornecedor="detalhesFornecedor"
          @voltar-exibir-graficos-tela-compras="detalhesFornecedor = true"
        />
      </v-flex>
      <v-flex xs5>
        <Detalhes
          :cardSelecionado="cardSelecionado"
          :exibirDetalhesFornecedor="detalhesFornecedor"
          @atualizarProdutos="atualizarProdutos = $event"
          @atualizarTelaCompras="atualizarTelaCompras = $event"
          @ocultarDetalhesProduto="ocultarDetalhesProduto = $event"
          @detalhesFornecedor="detalhesFornecedor = $event"
          @atualizar-produtos-total="atualizarProdutosTotal"
        ></Detalhes>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script setup>
import {useGrupoComprasUsuario} from "@/components/compra/ProdutosGerais/Filtros/GrupoFilialComprasDinamicosDialog/grupoDinamicoUsuario";
import {onMounted, onUnmounted} from "vue";

const grupo_dinamico_usuario = useGrupoComprasUsuario();

onMounted(() => grupo_dinamico_usuario.gerenciarExibicaoGrupo({ exibir_grupo_dinamico: true }));
onUnmounted(() => grupo_dinamico_usuario.gerenciarExibicaoGrupo({ exibir_grupo_dinamico: false }));
</script>

<script>
import Breadcrumb from "./Breadcrumb";
import Menu from "./MenuProdutos";
import Produtos from "./TabelaProdutos";
import Detalhes from "./Detalhes";
import { mapGetters } from "vuex";
import ConfigFornecedorTelaCompra from "../../config/TelaCompraConfig";
import MixinCompra from "./MixinCompra";
import HeadersProdutosCompra from "./Headers/ProdutosCompra";
import HeadersProdutosSobEncomenda from "./Headers/ProdutosSobEncomenda";
import HeadersProdutosTotal from "./Headers/ProdutosTotal";
import HeadersProdutosTransito from "./Headers/ProdutosTransito";
import ConverterEmbalagem from "@/components/compra/Embalagem/ConverterEmbalagem";
import {MensagemEnvio} from "@/WebSocket/MensagemEnvio";

export default {
  components: {
    ConverterEmbalagem,
    Breadcrumb,
    Menu,
    Produtos,
    Detalhes
  },
  mixins: [ConfigFornecedorTelaCompra, MixinCompra],
  data() {
    return {
      cards: {
        produtosComprar: {
          titulo: "Itens a comprar",
          total: 0,
          ativo: false,
          showSelect: true,
          headers: HeadersProdutosCompra,
          itens: [],
          metodo: fornecedor => {
            this.Helpers.getProdutosCompraGrupo(
              fornecedor,
              this.grupoCompra,
              this.filialCompra,
              this.comprador.id,
              this.fornecedor.idSegmento
            );
          }
        },
        produtosSobEncomenda: {
          titulo: "Completar Compra",
          total: 0,
          ativo: false,
          showSelect: true,
          headers: HeadersProdutosSobEncomenda,
          chave_card: 'completar_compra',
          itens: [],
          metodo: fornecedor => {
            this.Helpers.getProdutosSobEncomendaGrupo(
              fornecedor,
              this.grupoCompra,
              this.filialCompra,
              this.comprador.id,
              this.fornecedor.idSegmento
            );
          }
        },
        produtosTotal: {
          titulo: "Mostrar todos",
          total: 0,
          ativo: false,
          showSelect: true,
          filtros: true,
          headers: HeadersProdutosTotal,
          itens: [],
          metodo: fornecedor => {
            this.Helpers.getProdutosCompraGeralGrupo(
              fornecedor,
              this.grupoCompra,
              this.filialCompra,
              this.comprador.id,
              this.fornecedor.idSegmento
            );
          }
        },
        produtosTransito: {
          titulo: "Itens em Trânsito",
          total: 0,
          ativo: false,
          showSelect: false,
          headers: HeadersProdutosTransito,
          itens: [],
          metodo: fornecedor => {
            this.Helpers.getProdutosTransitoGrupo(
              fornecedor,
              this.grupoCompra,
              this.filialCompra,
              this.comprador.id,
              this.fornecedor.idSegmento
            );
          }
        }
      },
      cardSelecionado: null,
      atualizarProdutos: 0,
      idSilenciar: 0,
      atualizarSilenciadosBreadcrumb: 0,
      atualizarSilenciados: 0,
      atualizarTelaCompras: {},
      detalhesFornecedor: true,
      ocultarDetalhesProduto: false
    };
  },
  computed: {
    ...mapGetters({
      fornecedor: "fornecedor/getFornecedor",
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
      comprador: "fornecedor/getComprador",
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster",
      carregandoItensCompra: "loading/getLoadingTable",
      produtosTelaCompra: "tabela_compra/getItensCarrinhoZero",
      atualizar_tela_compra_count_global: "tabela_compra/getAtualizarTelaCompraCount"
      // ULTIMA_MENSAGEM_RECEBIDA_WS: "WebSocket/getUltimaMensagemRecebida",
    }),
    ...mapGetters("notificacaoProdutoSilenciado", ["produtoSilenciadoQtde"]),
  },
  watch: {
    grupoCompra: function() {
      this.buscarTotais();
      this.detalhesFornecedor = true;
    },
    fornecedor: function() {
      this.buscarTotais();
      this.detalhesFornecedor = true;
    },
    filialCompra: function() {
      this.buscarTotais();
      this.detalhesFornecedor = true;
    },
    produtoSilenciadoQtde() {
      this.buscarTotais();
    },
    atualizarSilenciados() {
      this.buscarTotais();
      this.atualizarSilenciadosBreadcrumb += 1;
    },
    cardSelecionado() {
      this.detalhesFornecedor = true;
    },
    ocultarDetalhesProduto() {
      if (this.ocultarDetalhesProduto) {
        this.detalhesFornecedor = true;
        this.ocultarDetalhesProduto = false;
      }
    },
    embalagemMasterAtivada() {
      this.converterEmbalagemProdutosPorComprar();
    },
    carregandoItensCompra(carregando) {
      if (!carregando && this.embalagemMasterAtivada) {
        this.converterEmbalagemProdutosPorComprar();
      }
    },
    // ULTIMA_MENSAGEM_RECEBIDA_WS(mensagem) {
    //   if (parseInt(mensagem.idfornecedor) === parseInt(this.fornecedor.id)) {
    //     alert(`${mensagem.nome_usuario} entrou nessa tela.`);
    //   }
    // },
    atualizar_tela_compra_count_global() {
      this.buscarTotais();
      this.cardSelecionado.metodo(this.fornecedor.id, this.grupoCompra);
      this.detalhesFornecedor = true;
    }
  },
  created() {
    this.Helpers.verificarToken();
    this.buscarTotais();
  },
  // mounted() {
  //   if (!this.fornecedor || !this.fornecedor.id) return;
  //
  //   const mensagem = new MensagemEnvio([], {
  //     idfornecedor: this.fornecedor.id,
  //     nome_usuario: localStorage.nome,
  //   });
  //   this.$store.dispatch("WebSocket/enviarMensagem", mensagem);
  // },
  destroyed() {
    localStorage.analiseGrupoFornecedores = 'N';
  },
  methods: {
    converterEmbalagemProdutosPorComprar(){
      const produtos = this.converterEmbalagemItemsCompra(this.produtosTelaCompra)
      this.$store.dispatch("tabela_compra/setItems", produtos);
    },
    atualizarProdutosTotal: function () {
      this.buscarTotais();
      this.atualizarProdutos++;
    },
    buscarTotais() {
      this.Helpers.atualizarTotaisGrupo(
        this.fornecedor.id,
        this.grupoCompra,
        this.filialCompra,
        this.comprador.id,
        this.fornecedor.idSegmento
      );
    }
  }
};
</script>
<style>
.v-tabs-bar__content {
  border-bottom: 1px solid #f7f1f1;
  border-top: 1px solid #f7f1f1;
}
</style>
